import { Component, ChangeDetectionStrategy } from '@angular/core';
import { PairCodeInputComponent } from '@era/devices';

@Component({
  selector: 'era-pair-page',
  templateUrl: './pair.page.html',
  styleUrls: ['./pair.page.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [PairCodeInputComponent],
})
export class PairPage {}
